import { render, staticRenderFns } from "./Downgoods.vue?vue&type=template&id=199b6e43&"
import script from "./Downgoods.vue?vue&type=script&lang=js&"
export * from "./Downgoods.vue?vue&type=script&lang=js&"
import style0 from "./Downgoods.vue?vue&type=style&index=0&id=199b6e43&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199b6e43')) {
      api.createRecord('199b6e43', component.options)
    } else {
      api.reload('199b6e43', component.options)
    }
    module.hot.accept("./Downgoods.vue?vue&type=template&id=199b6e43&", function () {
      api.rerender('199b6e43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Downgoods.vue"
export default component.exports